<template>
  <div id="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

// We listen to the resize event
window.addEventListener("resize", () => {
  console.log("Resize event!");
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

export default {
  name: "app",
  beforeCreate() {
    if (this.$storage.get("parkendaToken")) {
      const timeout = setTimeout(() => {
        this.loading = true;
      }, 0);
      this.$http
        .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
          headers: {
            "x-access-token": this.$storage.get("parkendaToken")
          }
        })
        .then((response) => {
          this.$store.dispatch("SAVE_USER", response.data);
          this.$store.dispatch(
            "SAVE_TOKEN",
            this.$storage.get("parkendaToken")
          );
          console.log(response.data.language);
          // this.$store.dispatch("SET_LANGUAGE", response.data.language);
          // this.$store.dispatch(
          //   "SET_TRANSLATIONS",
          //   require(`./assets/i18n/${this.$store.getters.SELECTED_LANGUAGE}.json`)
          // );
        });
      console.log(this.$store.getters.SELECTED_LANGUAGE);

      //Language
      //We have to get language from DB
      this.$store.dispatch("SET_LANGUAGE", "en");
      //Generate translations object and save it to store
      this.$store.dispatch(
        "SET_TRANSLATIONS",
        require(`./assets/i18n/${this.$store.getters.SELECTED_LANGUAGE}.json`)
      );
      //end Language
    } else {
      this.$store.dispatch("SET_LANGUAGE", "en");
      this.$store.dispatch(
        "SET_TRANSLATIONS",
        require(`./assets/i18n/en.json`)
      );
      this.loading = false;
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue